import React from 'react'
// @ts-ignore
import { Table as NbUiTable } from '@netbasequid/core'

const SectionDivider = ({
  columnCount,
  children,
  testId
}: {
  columnCount: number
  children: React.ReactNode
  testId?: string
}) => (
  // use colspan will break the style of first column
  <NbUiTable.TableRow testId={testId} height="36px">
    <NbUiTable.TableCell textAlign="left">{children}</NbUiTable.TableCell>
    {Array.from({ length: columnCount - 1 }).map((current, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <NbUiTable.TableCell key={index}> </NbUiTable.TableCell>
    ))}
  </NbUiTable.TableRow>
)

export default SectionDivider
